import { render } from "./AdminPage.vue?vue&type=template&id=7d5a7a3c&scoped=true"
import script from "./AdminPage.vue?vue&type=script&lang=js"
export * from "./AdminPage.vue?vue&type=script&lang=js"

import "./AdminPage.vue?vue&type=style&index=0&id=7d5a7a3c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d5a7a3c"]])

export default __exports__